import { Component } from '@angular/core';

@Component({
  selector: 'app-yearly-salary-info',
  templateUrl: './yearly-salary-info.component.html',
  styleUrls: ['./yearly-salary-info.component.scss']
})
export class YearlySalaryInfoComponent {

}
